import { AuthGuard } from '../_guards';
import { Routes } from '@angular/router';
import { SecComponent } from './index';

export const SecRoutes: Routes = [
  {
    path: 'sec', canActivate: [AuthGuard], component: SecComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/sec/sec.routes.ts